/*
 * @Author: cc
 * @Date: 2019-12-10 10:21:24
 * @LastEditTime: 2021-11-10 11:17:13
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\editingCenter.js
 * @Description:
 */
'use strict';
angular.module('editingCenterModule', [
    'editingCenterRouterModule',
    'editingCenterLeftModule',
    'editingCenterAppModule',
    'editingCenterKuaishouModule', // 快手渠道
    'trsNavLocationModule',
    'trsEditorModule',
    'trsEditorAuthMoule',
    'trsUserSupportModule',
    'ngTagsInput',
    'mgcrea.ngStrap.typeahead',
    'mgcrea.ngStrap.popover',
    'mgcrea.ngStrap.select',
    'editingCenterIWoModule',
    'editingCenterNewspaperModule',
    'editingCenterWebsiteModule',
    'initSingleSelectionModule',
    'editingCenterServiceModule',
    'editctrInitBtnModule',
    'editctrFilterBtnModule',
    'editLeftRouterModule',
    'editctrSupportCreationModule',
    'editcenterRightsModule',
    'editIsLockModule',
    'editingCenterWeiBoModule',
    'sensitiveWordImportModule',
    'heimaCheckImportModule',
    'btnGroupsModule',
    'leftToolTipModule',
    'editHeaderModule',
    'toggleMainTextModule',
    'previewModule',
    'weixinModule',
    'posCalculateModule',
    'multipleSelectModule',
    'multichannelManuscriptsModult', // 多渠道稿件指令模块
    'timeSelectorWithSecondModule',
    'televisionModule',
    'broadcastModule',
    'previewReviseInfoModule',
    'relatedReportDirectiveModule', // 关联选题指令
    'remarksReminderModule', // 备注强提示指令
    'editingCenterTrillModule', // 新增抖音渠道
    'editingCenterBaijiahaoModule', // 百家号渠道
    'editCenterQiehaoModule',
    'editCenterToutiaohaoModule',
    'editPageModule', // 编辑页指令组合模块
    'editListModule', // 列表页指令组合模块
    'esSerachModule', // es搜索框指令
    'picsPreviewRebuildModule', // 图集详情页模块
    'fontSizeSwitchingModule', // 字体大小切换模块
    'trsChangeListStyleModule', // 切换字体大小
    'editCenterNewMediaPreviewModule', // 新媒体渠道查看页面
    'subjectOpertionLogModule',
    'editshortVideoModule', // 短视频渠道
]).controller('EditingCenterController', ['$scope', 'publicToolService', function ($scope, publicToolService) {
    $scope.hasEdit = false;
    publicToolService.queryModeconfiguration();
}]).value('editingMediatype', {
    // iwo：-1,APP：1，网站：2，报纸：3，微信：4，微博：5, 电视: 15, 广播: 16, 抖音：17,百家号：18,企鹅号：19
    iwo: -1,
    app: 1,
    website: 2,
    newspaper: 3,
    weixin: 4,
    weibo: 5,
    television: 15,
    broadcast: 16,
    trill: 17,
    baijiahao: 18,
    qiehao: 19,
    toutiaohao: 20,
    kuaishou: 25
}).value('editingMediaName', {
    1: '客户端',
    2: '网站',
    3: '纸媒',
    4: '微信',
    5: '微博',
    17: '抖音',
    18: '百家号',
    19: '企鹅号',
    20: '头条号',
}).value('editingMediatypeToPlat', {
    // 从editingMediatype翻译到渠道名
    '-1': 'iwo',
    '-2': 'iwo',
    '-10': 'virtual',
    1: 'app',
    2: 'website',
    3: 'newspaper',
    4: 'weixin',
    5: 'weibo',
    15: 'television',
    16: 'broadcast',
    17: 'trill',
    18: 'baijiahao',
    19: 'qiehao',
    20: 'toutiaohao',
    22: 'gxgk',
    23: 'cpgk',
    24: 'xhsnews',
    25: 'kuaishou'
}).value('editingChannelName', {
    '-1': 'iwo',
    1: 'app',
    2: 'website',
    3: 'newspaper',
    4: 'weixin',
    5: 'weibo',
    15: 'television',
    16: 'broadcast',
    17: 'trill',
    18: 'baijiahao',
    19: 'qiehao',
    20: 'toutiaohao',
    22: 'gxgk',
    25: 'kuaishou'
}).value('editPreviewPath', {
    path: {
        // 查看页跳转路径，微博（5）、抖音（17）没有查看页 电视（15）、广播（16）不知道是否存在跳转的情况，暂时不设置
        // '-1': 'iwopreview',
        '-1': 'fusionpreview',
        '-2': 'fusionpreview',
        '1': 'appPreview',
        '2': 'websitePreviewAll',
        '3': 'newspaperNewsPreview',
        '4': 'weixinPreview',
        // '5': null,
        '5': 'wbPreview',
        '15': 'manuscriptPreview',
        '16': 'broadcastmanuscriptPreview',
        '17': 'qiehaopreview', // 抖音详情和企鹅号的一样的
        '18': 'newMediaPreview',
        '19': 'newMediaPreview',
        '20': 'newMediaPreview',
        '22': 'resourcegxgkdetail',
        '23': 'resourcedetail',
        '24': 'resourcexhsgbigdatadetail' // 新华社跳转
    },
}).value('editorPath', {
    path: {
        '25': {
            7: 'kuaishoudraft',
        },
        '17': {
            7: 'trillnews',
        },
        '18': {
            1: 'baijiahaonews',
            2: 'baijiahaoatlas',
            7: 'baijiahaovideo',
        },
        '20': {
            1: 'toutiaohaonews',
            7: 'toutiaohaovideo',
        },
        '19': {
            1: 'qiehaonews',
            2: 'qiehaoatlas',
            7: 'qiehaovideo',
        },
        '3': {
            1: 'newspapertext',
            2: 'newspaperpic'
        },
        '2': {
            1: 'websitenews',
            2: 'websiteatlas',
            3: 'websitesubject',
            4: 'websitelinkdoc',
            7: 'websitevideo',
        },
        '1': {
            1: 'appnews',
            2: 'appatlas',
            3: 'appsubject',
            4: 'appwebsite',
            5: 'appactivity',
            6: 'apptopic',
            7: 'appvideo',
            8: 'applive',
            12: 'appaudio',
            14: 'operationalActivity',
            15: 'advertisement',
        },
        '5': {
            '17': 'weiboheadlinesedit',
            '16': 'weiboedit'
        },
        '15': {
            9: 'televisionmanuscript',
            11: 'televisionplannedorder'
        },
        '16': {
            9: 'broadcastmanuscript',
            11: 'broadcastplannedorder'
        },
        '-1': {
            '1': 'fusionnews',
            '2': 'fusionatlas',
            '4': 'fusionlinkdoc',
            '5': 'fusionactivity',
            '6': 'fusiontopic',
            '7': 'fusionvideo',
            '8': 'fusionlive',
            '9': 'iwobroadcasttvmanuscript',
            '11': 'iwoplannedorderedit',
        }
    }
}).value('newMediaPreviewType', {
    18: {
        1: 'baijiahao.daibian',
        2: 'baijiahao.daishen',
        3: 'baijiahao.yiqianfa',
    },
    19: {
        1: 'kuaibao.daibian',
        2: 'kuaibao.daishen',
        3: 'kuaibao.yiqianfa',
    },
    20: {
        1: 'toutiao.daibian',
        2: 'toutiao.daishen',
        3: 'toutiao.yiqianfa',
    }
}).value('mediaIconObj', {
    iconObj: {
        '1': '#icon-duan-xuanzhong',
        '2': '#icon-wang-xuanzhong1',
        '3': '#icon-bao-xuanzhong',
        '4': '#icon-xin_s',
        '5': '#icon-bo_s',
        '17': '#icon-dy-3',
        '18': '#icon-bjh-3',
        '19': '#icon-qie-3',
        '20': '#icon-toutiao',
    },
    highlightIconObj: {
        '1': '#icon-duan',
        '2': '#icon-wang',
        '3': '#icon-bao',
        '4': '#icon-xin',
        '5': '#icon-bo',
        '17': '#icon-dy-2',
        '18': '#icon-bjh-2',
        '19': '#icon-qie-2',
        '20': '#icon-toutiao1',
    }
}).directive('xssFilter', ['$parse', 'publicToolService',
    function ($parse, publicToolService) {// GOV-7949 xss过滤，当存在不安全输入时回退显示
        return {
            require: 'ngModel',
            link: function ($scope, element, attrs) {
                element.on('change', function () {
                    let newValue = element.val();

                    let str = window.filterXSS(newValue, {
                        whiteList: {}, // 白名单为空，表示过滤所有标签
                        onTag: function (tag, html) {
                            // 为了解决1<2>3，或者<格局>等<>包起来内容不是html标签的情况，使用黑名单进行过滤
                            // 黑名单的来源为xss.js中提供的白名单列表，若有问题或整理不够则后续修改黑名单即可
                            if (publicToolService.xssBlackList().includes(tag.toLocaleLowerCase())) {
                                return html.replace(/</g, '&lt;').replace(/>/g, '&gt;');
                            }
                        },
                        escapeHtml: function (html) {
                            return html;
                        }
                    });
                    $parse(attrs.ngModel).assign($scope, str); // 替换输入框中的值
                });
            }
        };
    }
]);
